import { createContext, PropsWithChildren, useContext } from 'react';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

interface WidgetDragDropProps {
  value: WidgetDragDrop;
}

interface WidgetDragDrop {
  canDrag: () => boolean;
  canDrop: () => boolean;
  canSkip: () => boolean;
  onDrop: (item: unknown, targetEntities?: Entities) => void;
  isEntitiesIdentical: boolean;
  customerToSupplierConversionEntity?: Entities;
}

const WidgetDragDropContext = createContext<WidgetDragDrop>({
  canDrag: () => true,
  canDrop: () => true,
  canSkip: () => true,
  onDrop: () => {},
  isEntitiesIdentical: false,
});

export const WidgetDragDropProvider = (
  props: PropsWithChildren<WidgetDragDropProps>
) => {
  const { children, value } = props;

  return (
    <WidgetDragDropContext.Provider value={value}>
      {children}
    </WidgetDragDropContext.Provider>
  );
};

export const useWidgetDrapDropContext = () => useContext(WidgetDragDropContext);
